'use strict';

let jsonData = require('./test_data.json');

// key: playerName,
// value: Array(Array(all_season_results), Array(season6_results),Array(season5_results),
// Array(season4_results), Array(season3_results). Array(season2_results))
// For more information on results, see getSeasonalResults() and countSeasonResults()
let seasonalResults = {};
let latestSeason = jsonData[0]["season"];
let currentSeason = jsonData[0]["season"];
// key: playerName,
// value: Array(Array(all_season_stats), Array(season6_stats),Array(season5_stats),
// Array(season4_stats), Array(season3_stats). Array(season2_stats))
// For more information on the stats, see countSeasonStats()

module.exports = class StatCalculator{
    seasonalResults = {};
    seasonalStats = {};
    latestSeason = 0;
    currentSeason = 0;
    games = [];
    players = []

    constructor(games, players){
        this.games = games
        this.latestSeason = games[0]["season"]
        this.currentSeason = games[0]["season"]
        this.players = players
    }


    runSandalfExe(){
        initializePlayers(this.players, this.seasonalResults)
        getSeasonalResults(this.games, this.seasonalResults, this.currentSeason, this.latestSeason);
        countSeasonResults(this.seasonalResults);
        this.seasonalStats = countSeasonStats(this.seasonalResults);
        return {seasonRes: this.seasonalResults, seasonStats: this.seasonalStats}
    }
}

function initializePlayers(players,resultDict){
    for(let player of players){
        resultDict[player.name] = [[], []];
    }
}

function prepareNewSeason(resultDict) {
    // Create new array to hold season results for each player
    for (const name in resultDict) {
        resultDict[name].push([])
    }
}

function getSeasonalResults(games, resultDict, current, latest) {
    for (let i = 0; i < games.length; i++) {
        let game = games[i];
        // Skip unfinished games
        if (game["state"] != 3) {
            continue;
        // Keep track of the season
        } else if (game["season"] != current) {
            current = game["season"];
            prepareNewSeason(resultDict);
        }
        let team1_score = game["team1_score"];
        let team2_score = game["team2_score"];
        // Get players
        for (let j in game["players"]) {
            let player = game["players"][j]["name"]
            let team = game["players"][j]["team"]
            if (!(player in resultDict)) {
                // New player, create necessary arrays to hold season results
                // .fill() doesn't work because it copies the reference
                console.log("Should not be here")
                resultDict[player] = Array.from({length:(latest - current + 2)},()=> ([]));
            }
            if (team == 2) {
                //Store result to correct season array
                resultDict[player][resultDict[player].length - 1].push(String(team2_score) + "-" + String(team1_score));
                //Store result to all season array
                resultDict[player][0].push(String(team2_score) + "-" + String(team1_score));
            } else {
                //Store result to correct season array
                resultDict[player][resultDict[player].length - 1].push(String(team1_score) + "-" + String(team2_score));
                //Store result to all season array
                resultDict[player][0].push(String(team1_score) + "-" + String(team2_score));
            }
        }
    }
}

function countSeasonResults(resultDict) {
    // Player
    for (const name in resultDict) {
        // Season
        for (let i = 0; i < resultDict[name].length; i++) {
            let twozero = 0;
            let twoone = 0;
            let zerotwo = 0;
            let onetwo = 0;
            // Result of game
            for (let j = 0; j < resultDict[name][i].length; j++) {
                if (!resultDict[name][i][j].localeCompare("2-0")) {
                    twozero++;
                } else if (!resultDict[name][i][j].localeCompare("2-1")) {
                    twoone++;
                } else if (!resultDict[name][i][j].localeCompare("0-2")) {
                    zerotwo++;
                } else if (!resultDict[name][i][j].localeCompare("1-2")) {
                    onetwo++;
                }
            }
            // Store counted results instead of every result
            resultDict[name][i] = [twozero, twoone, zerotwo, onetwo];
        }
    }
}

function countSeasonStats(resultDict) {
    // Player
    let seasonalStats = {}
    for (const name in resultDict) {
        seasonalStats[name] = Array.from({length:(resultDict[name].length)},()=> ([]));
        // Season
        for (let i = 0; i < resultDict[name].length; i++) {
            let stats = [];
            let results = resultDict[name][i];
            // 0. Played games
            stats.push(results[0] + results[1] + results[2] + results[3]);
            // 1. Win (games)
            stats.push(results[0] + results[1]);
            // 2. Losses (games)
            stats.push(results[2] + results[3]);
            // 3. Win-% (games)
            if (stats[0] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((stats[1] / stats[0] * 100).toFixed(2)));
            }
            // 4. Played rounds
            stats.push(2 * results[0] + 3 * results[1] + 2 * results[2] + 3 * results[3]);
            // 5. Wins (rounds)
            stats.push(2 * results[0] + 2 * results[1] + results[3]);
            // 6. Losses (rounds)
            stats.push(2 * results[2] + 2 * results[3] + results[1]);
            // 7. Win-% (rounds)
            if (stats[4] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((stats[5] / stats[4] * 100).toFixed(2)));
            }
            // 8. 2-0 Wins
            stats.push(results[0]);
            // 9. 2-0 Win-% (wins)
            if (stats[1] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[0] / stats[1] * 100).toFixed(2)));
            }
            // 10. 2-0 Win-% (all games)
            if (stats[0] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[0] / stats[0] * 100).toFixed(2)));
            }
            // 11. 2-1 Wins
            stats.push(results[1]);
            // 12. 2-1 Win-% (wins)
            if (stats[1] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[1] / stats[1] * 100).toFixed(2)));
            }
            // 13. 2-1 Win-% (all games)
            if (stats[0] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[1] / stats[0] * 100).toFixed(2)));
            }
            // 14. 0-2 Losses
            stats.push(results[2]);
            // 15. 0-2 Loss-% (losses)
            if (stats[2] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[2] / stats[2] * 100).toFixed(2)));
            }
            // 16. 0-2 Loss-% (all games)
            if (stats[0] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[2] / stats[0] * 100).toFixed(2)));
            }
            // 17. 1-2 Losses
            stats.push(results[3]);
            // 18. 1-2 Loss-% (losses)
            if (stats[2] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[3] / stats[2] * 100).toFixed(2)));
            }
            // 19. 1-2 Loss-% (all games)
            if (stats[0] == 0) {
                stats.push(0.00);
            } else {
                stats.push(parseFloat((results[3] / stats[0] * 100).toFixed(2)));
            }
            // 20. 2-0 Win-% (2 round games)
            if (stats[0] == 0) {
                stats.push(0.00);
            }
            else if (results[2] == 0) {
                stats.push(100.00);
            } else {
                stats.push(parseFloat((results[0] / (results[0] + results[2]) * 100).toFixed(2)));
            }
            // 21. 2-1 Win-% (3 round games)
            if (stats[0] == 0) {
                stats.push(0.00);
            }
            else if (results[3] == 0) {
                stats.push(100.00);
            } else {
                stats.push(parseFloat((results[1] / (results[1] + results[3]) * 100).toFixed(2)));
            }
            seasonalStats[name][i] = stats;
        }
    }
    return seasonalStats
}

if (require.main === module) {
    getSeasonalResults(jsonData, seasonalResults, currentSeason, latestSeason);
    // console.log(seasonalResults);
    countSeasonResults(seasonalResults);
    // console.log(seasonalResults);
    let seasonalStats = countSeasonStats(seasonalResults);
    console.log(seasonalStats);
} else {
    console.log('required as a module');
}
